import React, { useEffect } from 'react';

import { useLocaleSwitchApp } from '@base/hooks/i18n';

export default function PublicRecoveryRedirect({ storageKey }) {
  const switchApp = useLocaleSwitchApp();

  useEffect(() => {
    if (!storageKey) return;
    let redirectData;
    try {
      const storedRedirect = sessionStorage.getItem(storageKey);
      if (storedRedirect) {
        redirectData = JSON.parse(storedRedirect);
        sessionStorage.removeItem(storageKey);
      } else {
        return;
      }
    } catch {
      return;
    }
    const { route, search } = redirectData || {};
    switchApp(route || '/', search || undefined);
  }, [switchApp, storageKey]);

  return null;
}
